// extracted by mini-css-extract-plugin
module.exports = {"FloatingContainer":"styles_FloatingContainer__PrcAY","hidden":"styles_hidden__XeZY2","visible":"styles_visible__VJuVl"};